<script>
    import { Typography } from '../UI'
    import Chip from './Chip.svelte'
    export let title = ''
    export let label = ''
    export let info = []
    export let style = ''
    export let state = null
</script>

<div class="banner" {style}>
    <span style="justify-content: space-between;">
        <span>
            <Typography type="legend" style="margin: 0;padding" color="grey-800"
                >{label.toUpperCase()}</Typography
            >
            <Typography
                type="h2"
                style="margin: 0; gap: 20px; align-items: center; display: flex;padding"
            >
                {title}
                {#if state}
                    <div class="chip">
                        <a>{state}</a>
                    </div>
                {/if}
            </Typography>
        </span>
        <span style="flex-direction: row; gap: 68px">
            {#each info as { label, value }}
                <span style="width: 258px;">
                    <Typography
                        type="caption"
                        color="grey-800"
                        style="margin: 0;padding">{label}</Typography
                    >
                    <Typography type="caption" style="margin: 0;padding"
                        >{value}</Typography
                    >
                </span>
            {/each}
        </span>
    </span>
</div>

<style>
    .banner {
        width: 100%;
        position: relative;
        height: 138px;
        padding: 15px 68px;
        background-color: white;
        display: flex;
    }

    .chip {
        display: flex;
        position: relative;
        justify-content: center;
        align-items: center;
        background-color: var(--chip-color, rgba(0, 0, 0, 0.3));
        margin: 0;
        padding: 0px 8px;
        height: 25px;
        max-width: fit-content;
        font-size: 18px;
        border-radius: 5px;
        text-transform: uppercase;
    }

    .chip a {
        position: relative;
        color: white;
        font-weight: 600;
        margin: 0;
        padding: 0;
    }
    .banner span {
        width: 100%;
        display: flex;
        position: relative;
        flex-direction: column;
        margin: 0;
        padding: 0;
    }
</style>
